import React, { Component } from "react";
import ChoicePopup from "../2/Controls/ChoicePopup";
import ListingPage from "../2/Controls/ListingPage";
import Input from "../2/Controls/Input";
import Window from "../2/Controls/Window";
import ExportButton from "../2/Controls/ExportButton";
import Button from "../2/Controls/Button";
import * as actionTypes from "../../actionTypes";
import { exportFile } from "../../actions/DataExporter";

const customField1 = "Custom Field 1";
const customField2 = "Custom Field 2";
const customField3 = "Custom Field 3";
const customField4 = "Custom Field 4";
const customField5 = "Custom Field 5";
const customField6 = "Custom Field 6";

class SalesHistory extends Component {

  constructor(props) {
    super(props);

    this.state = {
      list: [],
      totalCount: 0,
      loading: false,
      page: 1,
      pageSize: 25,
      selectAll: false,
      stores: [],
      cashRegisters: [],
      showNewModal: false,
      showConvertPopup: false, // Fixed: Added missing state for convert popup
      searchParam: "",
      salesTransactionTypes: [],
      filter: {
        storeId: "",
        cashRegisterId: "",
        transactionTypeId: "",
        fromDate: "",
        toDate: "",
        transactionNo: "",
        customerFirstName: "",
        customerPhoneNo: "",
        customerEmailId: "",
      },
      showFilter: false,
      showOption: false,
      selectedRow: null,
      isFilterActive: false,
      showSelectionOption: false, // Added to track if any row is selected

      listPageSettings: {
        Title: "Sales History",
        Search: {
          showSearch: true,
          placeholder: "Search by transaction no, customer name, email id or phone no",
          onSearch: this.onSearch,
          onRefresh: this.onRefreshClick,
          onFilterClick: () => this.setState({ showFilter: true }),
          isFilterActive: false
        },
        HeaderButtons: [
          {
            ButtonType: "Button",
            Type: "secondary",
            Text: "Copy",
            Icon: "",
            Action: "copy"
          },
          {
            ButtonType: "Button",
            Type: "secondary",
            Text: "Convert",
            Icon: "",
            Action: "convert"
          },
          {
            ButtonType: "Button",
            Type: "primary",
            Text: "New",
            Icon: "add",
            Action: "new"
          },
          {
            ButtonType: "ImageButton",
            Type: "option",
            Text: "Options",
            Icon: "option",
            Action: "options"
          }
        ],
        Columns: [
          { Name: "", Type: "checkbox" },
          {
            Name: "#",
            Type: "multiple",
            Columns: [
              { Column: "TransactionNo" },
              { Column: "TransactionType.TransactionType" },
              { Column: "CancellationReason", Type: "badge", CSS: "red", condition: (row) => row.hasOwnProperty("CancellationReason") && row.CancellationReason !== "" },
              { Column: "DeliveryStatus", Type: "badge", CSS: "green", condition: (row) => row.hasOwnProperty("DeliveryStatus") && row.DeliveryStatus !== "" },
              { Column: "ParentTransactionNo", Type: "badge", CSS: "green", condition: (row) => row.hasOwnProperty("ParentTransactionNo") && row.ParentTransactionNo !== "" },
              {
                Column: "SalesReturnTransactionNo",
                Label: "Sales return done via ",
                Type: "badge",
                CSS: "orange-red",
                condition: (row) => row.hasOwnProperty("SalesReturnTransactionNo") && row.SalesReturnTransactionNo !== ""
              },
              { Column: "ChildTransactionNo", Type: "badge", CSS: "orange", condition: (row) => row.hasOwnProperty("ChildTransactionNo") && row.ChildTransactionNo !== "" },
            ],
          },
          {
            Name: "Date",
            Type: "field",
            Columns: [{ Column: "TransactionDate", Type: "date" }],
          },
          {
            Name: "Store",
            Type: "multiple",
            Columns: [
              { Column: "Store.StoreName" },
              { Column: "CashRegister.CashRegisterName", Label: "CR" },
            ],
          },
          {
            Name: "Customer",
            Type: "multiple",
            Columns: [
              { Column: "CustomerName", condition: (row) => row.hasOwnProperty("CustomerName") && row.CustomerName !== "" },
              {
                Column: "Customer.EmailID",
                condition: (row) => row.hasOwnProperty("Customer") && row.Customer !== null &&
                  row.Customer !== undefined &&
                  row.Customer.hasOwnProperty("EmailID") &&
                  row.Customer.EmailID !== ""
              },
              {
                Column: "Customer.PhoneNo",
                condition: (row) => row.hasOwnProperty("Customer") && row.Customer !== null &&
                  row.Customer !== undefined &&
                  row.Customer.hasOwnProperty("PhoneNo") &&
                  row.Customer.PhoneNo !== ""
              },
              { Column: "CustomField1", Label: customField1, condition: (row) => row.hasOwnProperty("CustomField1") && row.CustomField1 !== "" },
              { Column: "CustomField2", Label: customField2, condition: (row) => row.hasOwnProperty("CustomField2") && row.CustomField2 !== "" },
              { Column: "CustomField3", Label: customField3, condition: (row) => row.hasOwnProperty("CustomField3") && row.CustomField3 !== "" },
              { Column: "CustomField4", Label: customField4, condition: (row) => row.hasOwnProperty("CustomField4") && row.CustomField4 !== "" },
              { Column: "CustomField5", Label: customField5, condition: (row) => row.hasOwnProperty("CustomField5") && row.CustomField5 !== "" },
              { Column: "CustomField6", Label: customField6, condition: (row) => row.hasOwnProperty("CustomField6") && row.CustomField6 !== "" },
              {
                Column: "BillingAddress.AddressType",
                Type: "text",
                Label: "Address",
                condition: (row) => row.hasOwnProperty("BillingAddress.AddressType") && row.BillingAddress.AddressType !== ""
              },
              { Column: "BillingAddress.Address1", Type: "text", condition: (row) => row.hasOwnProperty("BillingAddress.Address1") && row.BillingAddress.Address1 !== "" },
              { Column: "BillingAddress.Address2", Type: "text", condition: (row) => row.hasOwnProperty("BillingAddress.Address2") && row.BillingAddress.Address2 !== "" },
              { Column: "BillingAddress.City", Type: "text", condition: (row) => row.hasOwnProperty("BillingAddress.City") && row.BillingAddress.City !== "" },
              { Column: "BillingAddress.State", Type: "text", condition: (row) => row.hasOwnProperty("BillingAddress.State") && row.BillingAddress.State !== "" },
              { Column: "BillingAddress.Country", Type: "text", condition: (row) => row.hasOwnProperty("BillingAddress.Country") && row.BillingAddress.Country !== "" },
              { Column: "BillingAddress.PostalCode", Type: "text", condition: (row) => row.hasOwnProperty("BillingAddress.PostalCode") && row.BillingAddress.PostalCode !== "" },
            ],
          },
          {
            Name: "Qty",
            Type: "field",
            Columns: [{ Column: "BillQty", Type: "number" }],
          },
          {
            Name: "Sub Total",
            Type: "field",
            Columns: [{ Column: "BillSubTotal", Type: "number" }],
          },
          {
            Name: "Tax",
            Type: "field",
            Columns: [{ Column: "BillTaxAmount", Type: "number" }],
          },
          {
            Name: "Discount",
            Type: "field",
            Columns: [{ Column: "BillDiscount", Type: "number" }],
          },
          {
            Name: "Total",
            Type: "field",
            Columns: [{ Column: "BillAmount", Type: "number" }],
          },
          {
            Name: "Paid",
            Type: "field",
            Columns: [{ Column: "BillPaidAmount", Type: "number" }],
          },
          {
            Name: "Balance",
            Type: "field",
            Columns: [{ Column: "BalanceAmount", Type: "number" }],
          },
          {
            Name: "Payment Type",
            Type: "payments",
            Columns: [{ Column: "Payments", Type: "payments" }],
          },
          {
            Name: "Name",
            Type: "field",
            ShowInMobile: true,
            Columns: [
              { Column: "TransactionNo", CSS: "bold" },
              { Column: "TransactionType.TransactionType" },
              { Column: "TransactionDate", Type: "date" },
              { Column: "CancellationReason", Type: "badge", CSS: "red" },
              { Column: "DeliveryStatus", Type: "badge", CSS: "green" },
              { Column: "CustomerName" },
              { Column: "Customer.EmailID" },
              { Column: "Customer.PhoneNo" },
              { Column: "BillQty", Type: "text", Label: "Qty" },
              { Column: "BillAmount", Type: "text", Label: "Amount" },
              { Column: "Status", Type: "badge" },
            ],
          },
        ],
        RowButtons: [
        ]
      }
    };
  }

  // Fixed: Added checkboxSelected method
  checkboxSelected = (index) => {
    let list = [...this.state.list];

    if (index === -1) {
      let selectAll = !this.state.selectAll;
      list = list.map(l => ({ ...l, Selected: selectAll }));
      this.setState({ selectAll: selectAll, list: list });
    } else {
      if (index < list.length) {
        list[index] = { ...list[index], Selected: !list[index].Selected };
        this.setState({ list: list });
      }
    }

    // check if at least one row is selected
    const hasSelected = list.filter(f => f.Selected).length > 0;
    this.setState({ showSelectionOption: hasSelected });
  };

  async loadCashRegister(storeId) {
    let cashRegisters = await this.props.getCashRegisters(storeId);
    this.setState({ cashRegisters: cashRegisters });
  }


  renderNewSalesPopup() {
    return (
      <React.Fragment>
        {this.state.salesTransactionTypes.map((e) => (
          <Button
            key={e.key}
            text={"New " + e.TransactionType}
            type="secondary"
            icon="add"
            onClick={() => {
              this.props.history.push({
                pathname: "/home/sales/sales/",
                state: {
                  transactionType: e,
                  type: actionTypes.SALE_NEW
                },
              });
            }}
          />
        ))}
      </React.Fragment>
    );
  }

  renderConvertSales() {
    return (
      <React.Fragment>
        {this.state.salesTransactionTypes
          .filter(
            (e) =>
              e.Module === "sales" &&
              !e.IsDeleted &&
              e.TransactionType.toLowerCase().trim() !== "receive payment"
          )
          .map((e) => (
            <Button
              key={e.key}
              text={"New " + e.TransactionType}
              type="secondary"
              icon="add"
              onClick={() => {
                this.onConvertTransaction(e, false);
                this.setState({ showConvertPopup: false });
              }}
            />
          ))}
      </React.Fragment>
    );
  }


  showTransactionType(transactionType) {
    // console.log("showTransactionType transactionType", transactionType);
    let showModule = false;
    if (
      this.props.user.user.Role === "Power User" ||
      this.props.user.user.Role === "Store Owner" ||
      this.props.user.user.Role === "Store Manager" ||
      this.props.user.user.Role === "Store Cashier"
    ) {
      showModule = true;
    } else {
      if (
        this.props.user.acl.filter(
          (e) => e.id === transactionType.TransactionType && e.perms.read
        ).length > 0
      ) {
        // console.log('i.TransactionType', i.TransactionType);
        // console.log('perms', this.props.user.acl.filter(e=>e.id === i.TransactionType && e.perms.read));
        showModule = true;
      }
    }
    if (this.props.registration.registration.PincodeIntegration) {
      if (
        this.props.registration.registration.hasOwnProperty(
          "PinocdeOrderTransactionTypeID"
        ) &&
        this.props.registration.registration.PinocdeOrderTransactionTypeID ===
        transactionType.key
      ) {
        showModule = false;
      }
    }
    return showModule;
  }
  // componentDidMount() {
  //   let salesTransactionTypes = [];

  //   this.props.config.TransactionTypes.filter(
  //     (e) => e.Module === "sales" && !e.IsDeleted
  //   ).map((e) => {
  //     if (this.showTransactionType(e)) {
  //       salesTransactionTypes.push(e);
  //     }
  //   });

  //   const defaultStoreId = this.props.user.store.key;
  //   console.log("this.props.config.UserStores", this.props.config.UserStores);
  //   this.setState(
  //     {
  //       filter: {
  //         ...this.state.filter,
  //         storeId: defaultStoreId
  //       },
  //       salesTransactionTypes: salesTransactionTypes,
  //       stores: this.props.config.UserStores
  //     },
  //     () => {
  //       // ✅ Runs AFTER state is updated
  //       this.loadCashRegister(defaultStoreId);
  //       this.loadData();
  //     }
  //   );



  // }
  componentDidMount() {

     console.log(" this.props.getVisibility",this.props.getVisibility("Sales", "export"));
     console.log("this.props.user", this.props.user.user);
    let saved = this.props.getPageFilters("SalesHistory");

    let page = 1;
    let pageSize = 25;
    let searchParam = "";
    let isFilterActive = false;
    let filter = { ...this.state.filter };



    if (saved) {
      console.log("saved", saved);
      filter = saved.PageFilters || filter;
      searchParam = saved.SearchText || "";
      page = saved.ActivePage || 1;
      isFilterActive = saved.IsFilterActive;

      // recordFrom → convert back to page
      if (saved.RecordFrom) {
        page = Math.floor(saved.RecordFrom / pageSize) + 1;
      }
    }

    let salesTransactionTypes = [];

    this.props.config.TransactionTypes
      .filter((e) => e.Module === "sales" && !e.IsDeleted)
      .map((e) => {
        if (this.showTransactionType(e)) {
          salesTransactionTypes.push(e);
        }
      });

    const storeId = filter.storeId || this.props.user.store.key;
    console.log("searchparam", searchParam);
    this.setState(
      {
        filter: {
          ...filter,
          storeId: storeId,
        },
        isFilterActive: isFilterActive,
        searchParam: searchParam,
        page,
        salesTransactionTypes,
        stores: this.props.config.UserStores,
      },
      () => {
        this.loadCashRegister(storeId);
        this.loadData();
      }
    );
  }

  savePageFilters = () => {
    const { filter, searchParam, page, pageSize, isFilterActive } = this.state;
    console.log("418 saving page filters");
    this.props.setPageFilters(
      "SalesHistory",
      filter,
      searchParam,
      (page - 1) * pageSize, // recordFrom
      page,
      isFilterActive
    );
  };
  getSelectedStoreIds = () => {
    var storeId = this.state.filter.storeId;

    if (!storeId) {
      var keys = this.state.stores
        .filter(function (s) {
          return (s.key !== null && s.key !== undefined && s.key !== "");
        })
        .map(function (s) {
          return s.key;
        });
      return keys;
    }
    return storeId;
  };

  loadData = async () => {
    this.setState({ loading: true });

    try {
      const { page, pageSize, filter, searchParam } = this.state;
      const from = (page - 1) * pageSize;

      const res = await this.props.getSalesHistory(
        from,
        pageSize,
        null,
        this.getSelectedStoreIds(),
        filter.fromDate,
        filter.toDate,
        filter.cashRegisterId,
        filter.transactionTypeId,
        filter.transactionNo,
        filter.customerFirstName,
        filter.customerEmailId,
        filter.customerPhoneNo,
        searchParam
      );

      let list = [];
      let totalCount = 0;

      if (res && res.hasOwnProperty("sales") && res.sales.length > 0) {
        list = res.sales.map((data) => {
          let formattedData = { ...data, Selected: false }; // Added Selected property

          // Customer Name
          formattedData.CustomerName = formattedData.Customer
            ? (formattedData.Customer.FirstName || "") + " " + (formattedData.Customer.LastName || "")
            : "";

          // Cancelled
          formattedData.Cancelled = formattedData.CancellationReason ? "Yes" : "No";

          // Initialize Payments array
          if (
            formattedData.hasOwnProperty("ReceivedPaymentTransactions") &&
            formattedData.ReceivedPaymentTransactions.length > 0
          ) {

            console.log("receive payment record", formattedData);
            let balanceAmount = Number(formattedData.BalanceAmount);
            let receivedAount = 0;

            formattedData.ReceivedPaymentTransactions.map((r) => {
              if (r.hasOwnProperty("ReceiveAmount")) {
                receivedAount = Number(receivedAount) + Number(r.ReceiveAmount);
                if (formattedData.hasOwnProperty("Payments")) {
                  formattedData.Payments.push({
                    PaymentMode: r.ReceivePaymentNo,
                    Amount: r.ReceiveAmount,
                  });
                }
              }
            });
            balanceAmount = balanceAmount - receivedAount;
            formattedData.BalanceAmount = balanceAmount;
            formattedData.BillPaidAmount = Number(formattedData.BillAmount) - Number(balanceAmount);
          }


          return formattedData;
        });
      }

      if (res && res.hasOwnProperty("totalCount")) {
        totalCount = res.totalCount;
      }

      this.setState({
        list: list,
        totalCount: totalCount,
        loading: false,
        selectAll: false
      });
    } catch (error) {
      console.error(error);
      this.setState({ loading: false });
    }
  };



  onSearch = (text) => {
    this.setState({ searchParam: text, page: 1 }, () => {
      this.savePageFilters();
      this.loadData();
    });
  };

  onRefreshClick = () => {
    this.setState(
      {
        filter: {
          storeId: this.props.user.store.key,
          cashRegisterId: "",
          transactionTypeId: "",
          fromDate: "",
          toDate: "",
          transactionNo: "",
          customerFirstName: "",
          customerPhoneNo: "",
          customerEmailId: "",
        },
        page: 1,
        isFilterActive: false,
        searchParam: "",
      },
      () => {
        this.savePageFilters();
        this.loadData();
      }
    );
  };

  onNextClick = () => {
    const totalPages = Math.ceil(this.state.totalCount / this.state.pageSize);
    if (this.state.page < totalPages) {
      this.setState({ page: this.state.page + 1 }, this.loadData);
    }
  };

  onPreviousClick = () => {
    if (this.state.page > 1) {
      this.setState({ page: this.state.page - 1 }, this.loadData);
    }
  };

  onFirstClick = () => {
    this.setState({ page: 1 }, this.loadData);
  };

  onLastClick = () => {
    const totalPages = Math.ceil(this.state.totalCount / this.state.pageSize);
    this.setState({ page: totalPages }, this.loadData);
  };

  onRecordsPerPageCountChange = (size) => {
    this.setState({ pageSize: Number(size), page: 1 }, this.loadData);
  };



  onApplyFilter = () => {
    this.setState(
      { page: 1, showFilter: false, isFilterActive: true },
      () => {
        this.savePageFilters();
        this.loadData();
      }
    );
  };

  onClearFilter = () => {
    this.onRefreshClick();
    this.setState({ showFilter: false });
  };

  exportColumns = [
    { header: "Store header", field: "Store.StoreName" },
    {
      header: "Cash Register",
      field: "CashRegister.CashRegisterName",
    },
    {
      header: "Customer Code",
      field: "Customer.CustomerCode",
    },
    {
      header: "Customer First header",
      field: "Customer.FirstName",
    },
    {
      header: "Customer Last header",
      field: "Customer.LastName",
    },
    {
      header: "Customer Mobile No.",
      field: "Customer.PhoneNo",
    },
    {
      header: "Customer Code",
      field: "Customer.CustomerCode",
    },

    ...(this.props.registration.registration.hasOwnProperty("BusinessTypeID") && this.props.registration.registration.BusinessTypeID === "7"
      ? [
        { header: "Pet Type", field: "PetDetails.Type" },
        { header: "Pet Name", field: "PetDetails.PetName" },
        { header: "Pet Breed", field: "PetDetails.Breed" },
        { header: "Pet Gender", field: "PetDetails.Gender" },
        { header: "Pet Height", field: "PetDetails.Height" },
        { header: "Pet Weight", field: "PetDetails.Weight" },
      ]
      : []),

    { header: "Transaction No", field: "TransactionNo" },
    {
      header: "Transaction type",
      field: "TransactionType.TransactionType",
    },
    { header: "Transaction Date", field: "TransactionDate", type: "date" },
    { header: "Qty", field: "BillQty", type: "number" },
    { header: "Sub Total", field: "BillSubTotal", type: "number" },
    { header: "Total Tax", field: "BillTaxAmount", type: "number" },
    { header: "Discount", field: "BillDiscount", type: "number" },
    { header: "Total", field: "BillAmount", type: "number" },
    { header: "Paid", field: "BillPaidAmount", type: "number" },
    { header: "Balance", field: "BalanceAmount", type: "number" },
    { header: "RoundOff", field: "RoundOff", type: "number" },
    { header: "Cancelled", field: "Cancelled" },
    {
      header: "CancellationReason",
      field: "CancellationReason",
    },
    { header: "Notes", field: "Notes" },
    {
      header: "SalesReturnTransactionNo",
      field: "SalesReturnTransactionNo",
    },
    {
      header: "customField1",
      field: "Customer.CustomField1",
    },
    {
      header: "customField2",
      field: "Customer.CustomField2",
    },
    {
      header: "customField3",
      field: "Customer.CustomField3",
    },
    {
      header: "customField4",
      field: "Customer.CustomField4",
    },
    {
      header: "customField5",
      field: "Customer.CustomField5",
    },
    {
      header: "customField6",
      field: "Customer.CustomField6",
    },
    {
      header: "BillingAddressType",
      field: "BillingAddress.AddressType",
    },
    {
      header: "BillingAddressLine1",
      field: "BillingAddress.Address1",
    },
    {
      header: "BillingAddressLine2",
      field: "BillingAddress.Address2",
    },
    {
      header: "BillingAddressCity",
      field: "BillingAddress.City",
    },
    {
      header: "BillingAddressState",
      field: "BillingAddress.State",
    },
    {
      header: "BillingAddressCountry",
      field: "BillingAddress.Country",
    },
    {
      header: "BillingAddressPostalCode",
      field: "BillingAddress.PostalCode",
    },
    {
      header: "DeliveryAddressType",
      field: "DeliveryCustomerAddress.AddressType",
    },
    {
      header: "DeliveryAddressLine1",
      field: "DeliveryCustomerAddress.Address1",
    },
    {
      header: "DeliveryAddressLine2",
      field: "DeliveryCustomerAddress.Address2",
    },
    {
      header: "DeliveryAddressCity",
      field: "DeliveryCustomerAddress.City",
    },
    {
      header: "DeliveryAddressState",
      field: "DeliveryCustomerAddress.State",
    },
    {
      header: "DeliveryAddressCountry",
      field: "DeliveryCustomerAddress.Country",
    },
    {
      header: "DeliveryAddressPostalCode",
      field: "DeliveryCustomerAddress.PostalCode",
    },
    { header: "Change Due", field: "BillChangeDue" },

    // IMPORTANT: This will be replaced dynamically
    { header: "Payments", field: "Payments", type: "payments" },

    {
      header: "TransactionDateTime",
      field: "TransactionDate",
      type: "date",
    },
    { header: "", field: "ReceivedPaymentTransactions" },
  ];
  getExportData = async () => {
    const MAX_RECORDS = 10000;
    const PAGE_SIZE = 2000;

    let allSales = [];
    let currentPage = 0;
    let hasMoreData = true;
    let totalCount = 0;

    try {
      while (hasMoreData) {
        const res = await this.props.getSalesHistory(
          currentPage * PAGE_SIZE, // offset
          PAGE_SIZE,               // batch size
          null,
          this.getSelectedStoreIds(),
          this.state.filter.fromDate,
          this.state.filter.toDate,
          this.state.filter.cashRegisterId,
          this.state.filter.transactionTypeId,
          this.state.filter.transactionNo,
          this.state.filter.customerFirstName,
          this.state.filter.customerEmailId,
          this.state.filter.customerPhoneNo,
          this.state.searchParam
        );

        if (!res || !res.hasOwnProperty("sales")) {
          break;
        }

        // First call → determine total capped at 10k
        if (currentPage === 0) {
          totalCount = Math.min(res.totalCount || 0, MAX_RECORDS);
        }

        if (Array.isArray(res.sales)) {
          const remaining = MAX_RECORDS - allSales.length;
          allSales.push(...res.sales.slice(0, remaining));
        }

        // Stop condition
        if (allSales.length < totalCount) {
          currentPage++;
        } else {
          hasMoreData = false;
        }
      }

      return allSales;
    } catch (err) {
      console.error("Error fetching export data:", err);
      return [];
    }
  };

  handleExport = async (type) => {
    this.setState({ loading: true });

    try {
      const data = await this.getExportData();
      const paymentTypes = this.props.config.PaymentTypes;

      if (!data || data.length === 0) {
        alert("No data available to export");
        return;
      }

      /* ----------------------------------
         Build Dynamic Payment Columns
      -----------------------------------*/
      const paymentColumns = paymentTypes.map((pt) => ({
        header: pt.PaymentType,
        field: pt.PaymentType,
        type: "number",
      }));

      // Remove old Payments column
      const staticCols = this.exportColumns.filter(function (col) {
        return col.field !== "Payments";
      });

      // Insert payment columns after BillChangeDue
      const changeDueIndex = staticCols.findIndex(function (col) {
        return col.field === "BillChangeDue";
      });

      let finalColumns = [];

      if (changeDueIndex !== -1) {
        finalColumns = staticCols
          .slice(0, changeDueIndex + 1)
          .concat(paymentColumns)
          .concat(staticCols.slice(changeDueIndex + 1));
      } else {
        finalColumns = staticCols.concat(paymentColumns);
      }

      /* ----------------------------------
         Flatten Sales Data (SUM payments)
      -----------------------------------*/
      const flattenedData = data.map(function (sale) {
        const flatSale = Object.assign({}, sale);

        // Initialize payment columns
        paymentTypes.forEach(function (pt) {
          flatSale[pt.PaymentType] = 0;
        });

        if (sale.hasOwnProperty("Payments") && Array.isArray(sale.Payments)) {
          sale.Payments.forEach(function (payment) {
            const mode = payment.PaymentMode;
            const amount = Number(payment.Amount) || 0;

            if (flatSale.hasOwnProperty(mode)) {
              flatSale[mode] = flatSale[mode] + amount;
            } else {
              flatSale[mode] = amount;
            }
          });
        }

        return flatSale;
      });

      // ✅ USE finalColumns and flattenedData (this was missing)
      await exportFile({
        data: flattenedData,
        columns: finalColumns,
        fileType: type,
        title: "SalesHistory",
        landscape: true,
      });
    } catch (error) {
      console.error(error);
      alert("Export failed");
    } finally {
      this.setState({ loading: false });
    }
  };

  async onConvertTransaction(transactionType, copy = false) {
    let selectedRecords = [];
    let selectedRecordsTemp = [];
    let firstRecordTransactionType = null;
    let firstRecordCustomer = null;
    let firstRecord = false;
    let firstRecordData = null;
    let paymentReceivedForSelectedTransaction = false;
    let receivedPaymentAmount = 0;
    let convertedFromTransactionBalanceAmount = 0;

    selectedRecordsTemp = this.state.list.filter((f) => f.Selected);

    if (selectedRecordsTemp.length === 0) {
      alert("Please select record(s).");
      return;
    }

    for (let k = 0; k < selectedRecordsTemp.length; k++) {
      let record = await this.props.getSaleDetails(selectedRecordsTemp[k].key);
      record.key = selectedRecordsTemp[k].key;
      selectedRecords.push(record);
    }

    for (let i = 0; i < selectedRecords.length; i++) {
      let record = selectedRecords[i];
      if (!firstRecord) {
        firstRecordData = selectedRecords[i];
        firstRecordTransactionType = record.TransactionType;
        firstRecordCustomer = record.Customer;
        firstRecord = true;
        if (transactionType && transactionType.TransactionType === firstRecordTransactionType.TransactionType) {
          alert("Transaction can not be converted to same type. Please select different transaction types.");
          return;
        }
      } else {
        if (record.TransactionType.TransactionType !== firstRecordTransactionType.TransactionType) {
          alert("Selected records should be of same transaction type");
          return;
        }
        if (!firstRecordCustomer && record.Customer) {
          alert("Selected records should have same customer");
          return;
        }
        if (firstRecordCustomer && !record.Customer) {
          alert("Selected records should have same customer");
          return;
        }
        if (firstRecordCustomer && record.Customer) {
          if (firstRecordCustomer.key !== record.Customer.key) {
            alert("Selected records should have same customer");
            return;
          }
        }
      }
      if (!copy && record.hasOwnProperty("ChildTransactionNo")) {
        if (record.ChildTransactionNo && record.ChildTransactionNo.trim() !== "") {
          alert("#" + record.TransactionNo + " is already converted");
          return;
        }
      }
      if (record.Payments && record.Payments.length > 0) {
        receivedPaymentAmount = record.BillPaidAmount;
        convertedFromTransactionBalanceAmount = record.BalanceAmount;
        paymentReceivedForSelectedTransaction = true;
      }
    }

    if (!copy && paymentReceivedForSelectedTransaction && selectedRecords.length > 1) {
      alert("Payment collected for one or more transaction. Please select only one transaction at a time to convert.");
      return;
    }

    // Create new sale object
    let sale = {
      TransactionType: firstRecordTransactionType,
      Customer: firstRecordCustomer,
      RegistrationID: this.props.user.user.RegistrationID,
      CashRegister: null,
      Store: this.props.user.store,
      LineItems: [],
      BillQty: 0,
      BillSubTotal: 0,
      BillDiscount: 0,
      BillTaxAmount: 0,
      BillAmount: 0,
      RoundOff: 0,
      BillBalanceAmount: 0,
      BillPaidAmount: 0,
      BillChangeDue: 0,
      Payments: null,
      ParentTransactionNo: "",
      ParentTransactionKey: "",
      Employee: null,
      Notes: "",
      TaxSummaryList: [],
      PlaceOfSupply: "",
      BillingAddress: null,
      DeliveryCustomer: null,
      DeliveryCustomerAddress: null,
      DeliveryDate: "",
      DeliveryTime: "",
      deliveryNotes: "",
      BackEndUpdate: false,
      ReceivedPaymentAmount: !copy ? receivedPaymentAmount : 0,
      ConvertedFromTransactionBalanceAmount: !copy ? convertedFromTransactionBalanceAmount : 0,
      IsConvert: !copy,
    };

    if (paymentReceivedForSelectedTransaction && !copy) {
      sale.ReceivedPaymentTransactions = [];
      sale.ReceivedPaymentTransactions.push({
        ReceiveAmount: receivedPaymentAmount,
        ReceivePaymentDate: null,
        ReceivePaymentKey: firstRecordData.key,
        ReceivePaymentNo: firstRecordData.TransactionNo,
        IsConvert: true,
      });
    }

    for (let i = 0; i < selectedRecords.length; i++) {
      let record = selectedRecords[i];
      // Copy custom fields
      for (let j = 1; j <= 20; j++) {
        sale[`CustomField${j}`] = record.hasOwnProperty(`CustomField${j}`) ? record[`CustomField${j}`] : "";
      }

      record.LineItems.map((l) => {
        if (!copy) {
          l.ParentTransactionNo = record.TransactionNo;
          l.ParentTransactionKey = record.key;
          l.ParentTransactionType = record.TransactionType.TransactionType;
          l.Notes =
            record.TransactionNo +
            " (" +
            new Date(record.TransactionDate).toString().substring(0, 24) +
            ")";
        }
        sale.LineItems.push(l);
      });
    }

    if (firstRecordTransactionType.hasOwnProperty("UpdateStockChecked")) {
      if (firstRecordTransactionType.UpdateStockChecked && !copy) {
        firstRecordTransactionType.UpdateStockChecked = false;
      }
    }

    this.props.history.push({
      pathname: "/home/sales/sales/",
      state: {
        type: actionTypes.SALE_NEW,
        key: "",
        transactionType: copy ? firstRecordTransactionType : transactionType,
        sale: sale,
      },
    });
  }

  onHeaderButtonClicked = (btn) => {
    if (btn.Action === "new") {
      this.setState({ showNewModal: true });
    }
    if (btn.Action === "copy") {
      this.onConvertTransaction(null, true);
    }
    if (btn.Action === "convert") {
      this.setState({ showConvertPopup: true });
    }
    if (btn.Action === "options") {
      this.setState({ showOption: true });
    }
  };




  onPageChange = (page, pageSize) => {
    this.setState(
      { page, pageSize },
      () => {
        this.savePageFilters();
        this.loadData();
      }
    );
  };
  render() {
    const headerButtons = [
      {
        ButtonType: "Button",
        Type: "primary",
        Text: "New",
        Icon: "add",
        Action: "new"
      },
      {
        ButtonType: "ImageButton",
        Type: "option",
        Text: "Options",
        Icon: "option",
        Action: "options"
      }
    ];

    // Add Copy and Convert buttons only if at least one row is selected
    if (this.state.showSelectionOption) {
      headerButtons.unshift(
        {
          ButtonType: "Button",
          Type: "secondary",
          Text: "Copy",
          Icon: "",
          Action: "copy"
        },
        {
          ButtonType: "Button",
          Type: "secondary",
          Text: "Convert",
          Icon: "",
          Action: "convert"
        }
      );
    }

    const listPageSettings = {
      ...this.state.listPageSettings,
      HeaderButtons: headerButtons,
      Search: {
        ...this.state.listPageSettings.Search,
        isFilterActive: this.state.isFilterActive
      }
    };
    return (
      <>
        <ListingPage
          {...this.props}
          listPageSettings={listPageSettings}
          list={this.state.list}
          loading={this.state.loading}
          totalItemsCount={this.state.totalCount}
          recordFrom={(this.state.page - 1) * this.state.pageSize}
          itemsCountPerPage={this.state.pageSize}
          onNextClick={this.onNextClick}
          onPreviousClick={this.onPreviousClick}
          onFirstClick={this.onFirstClick}
          onLastClick={this.onLastClick}
          onRecordsPerPageCountChange={this.onRecordsPerPageCountChange}
          checkboxSelected={this.checkboxSelected}
          selectAll={this.state.selectAll}
          onHeaderButtonClicked={this.onHeaderButtonClicked}
          onRowClick={(row) => {
            this.props.history.push("/home/sales/viewsales/" + row.key);
          }}
          onPageChange={this.onPageChange}
          searchText={this.state.searchParam}
        />

        {this.state.showFilter && (
          <Window
            header="Filter"
            size="small"
            slide={true}
            onClose={() => this.setState({ showFilter: false })}
            onButtonClick={(action) => {
              if (action === "Apply") this.onApplyFilter();
              if (action === "Clear") this.onClearFilter();
            }}
            buttons={[
              { Type: "secondary", Text: "Clear", Align: "left" },
              { Type: "primary", Text: "Apply", Align: "right" }
            ]}
          >
            <Input
              type="select"
              label="Store"
              value={this.state.filter.storeId}
              onChange={(v) => {
                this.setState({
                  filter: { ...this.state.filter, storeId: v }
                });
                this.loadCashRegister(v);
              }}
            >
              {this.state.stores.map((s) => (
                <option key={s.key} value={s.key}>
                  {s.StoreCode} {s.StoreName}
                </option>
              ))}
            </Input>

            <Input
              type="select"
              label="Cash Register"
              value={this.state.filter.cashRegisterId}
              onChange={(v) =>
                this.setState({
                  filter: { ...this.state.filter, cashRegisterId: v }
                })
              }
            >
              <option value="">All</option>
              {this.state.cashRegisters.map((c) => (
                <option key={c.key} value={c.key}>
                  {c.CashRegisterName}
                </option>
              ))}
            </Input>

            <Input
              type="select"
              label="Transaction Type"
              value={this.state.filter.transactionTypeId}
              onChange={(v) =>
                this.setState({
                  filter: { ...this.state.filter, transactionTypeId: v }
                })
              }
            >
              <option value="">All</option>
              {this.props.config.TransactionTypes.filter(
                (e) => e.Module === "sales" && !e.IsDeleted
              ).map((e) => (
                <option key={e.key} value={e.key}>{e.TransactionType}</option>
              ))}
            </Input>

            <Input
              type="date"
              label="From Date"
              value={this.state.filter.fromDate}
              onChange={(v) =>
                this.setState({
                  filter: { ...this.state.filter, fromDate: v }
                })
              }
            />

            <Input
              type="date"
              label="To Date"
              value={this.state.filter.toDate}
              onChange={(v) =>
                this.setState({
                  filter: { ...this.state.filter, toDate: v }
                })
              }
            />

            <Input
              type="text"
              label="Transaction No"
              value={this.state.filter.transactionNo}
              onChange={(v) =>
                this.setState({
                  filter: { ...this.state.filter, transactionNo: v }
                })
              }
            />

            <Input
              type="text"
              label="Customer Name"
              value={this.state.filter.customerFirstName}
              onChange={(v) =>
                this.setState({
                  filter: { ...this.state.filter, customerFirstName: v }
                })
              }
            />

            <Input
              type="text"
              label="Customer Contact No"
              value={this.state.filter.customerPhoneNo}
              onChange={(v) =>
                this.setState({
                  filter: { ...this.state.filter, customerPhoneNo: v }
                })
              }
            />

            <Input
              type="text"
              label="Customer Email Id"
              value={this.state.filter.customerEmailId}
              onChange={(v) =>
                this.setState({
                  filter: { ...this.state.filter, customerEmailId: v }
                })
              }
            />
          </Window>
        )}

        {this.state.showNewModal && (
          <ChoicePopup
            header={"New Transaction"}
            height={"200px"}
            stripNew
            onClose={() => this.setState({ showNewModal: false })}
          >
            {this.renderNewSalesPopup()}
          </ChoicePopup>
        )}

     {this.state.showOption && (
  <Window
    header="Options" choiceList
    size="small"
    slide={true}
    onClose={() => this.setState({ showOption: false })}
  >
    {this.props.user.user.hasOwnProperty("RoleKey") && 
     this.props.user.user.RoleKey !== "" && 
     this.props.getVisibility("Sales", "export") === "none" ? (
      null // or a placeholder component if needed
    ) : (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          width: "100%",
        }}
      >
        <ExportButton
          onExport={this.handleExport}
          loading={this.state.loading}
        />
      </div>
    )}
  </Window>
)}

        {this.state.showConvertPopup && (
          <ChoicePopup
            header="Convert"
            sheetTitle="Convert to"
            stripNew
            onClose={() => this.setState({ showConvertPopup: false })}
          >
            {this.renderConvertSales()}
          </ChoicePopup>
        )}
      </>
    );
  }
}

export default SalesHistory;